import { LOGGED_IN_CARDS_PER_PAGE } from '@/config';
import { useQuery } from '@apollo/client';
import { FOLLOWED_COMPANIES_QUERY } from '@/graphql/queries';

const useFollowedCompanies = ({ first = LOGGED_IN_CARDS_PER_PAGE } = {}) => {
  const { fetchMore, error, ...rest } = useQuery(FOLLOWED_COMPANIES_QUERY, {
    variables: { first },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  const pagination = async (endCursor: string) => {
    await fetchMore({
      variables: {
        first,
        after: endCursor,
      },
    });
  };

  return {
    pagination,
    error,
    ...rest,
  };
};

export { useFollowedCompanies };
